module.exports = __webpack_public_path__ + "img/great.31035d48.svg";